<template>
  <div>
    <div v-show="!isEdit && cooperateEdit" style="margin-top: 5px">
      <el-button type="primary" @click="export7501(true)">{{ $t('queryJob.customer') }}7501</el-button>
      <el-button type="primary" @click="export7501()">{{ $t('queryJob.CustomsClearance') }}7501</el-button>
      <el-button no="generateCostCharge" type="primary" @click="generateCostCharge">{{ $t('queryJob.GenerateReceivableExpense') }}</el-button>
      <el-button no="generateSellingCharge" type="primary" @click="generateSellingCharge">{{ $t('queryJob.GeneratePayableExpenses') }}</el-button>
      <el-button v-if="(job.lob === 'SE' || job.lob === 'AE') && readonly && showSync" type="primary" @click="exportSyncImport">{{ $t('SeaExport.Synchronization') }}</el-button>
    </div>
    <el-form :disabled="!isEdit || !cooperateEdit" style="margin: 5px 0 10px 0">
      <div class="flex-row-label">
        <div class="w-180 mRight-30">{{ $t('CargoMsg.Cargo_DataType') }}</div>
        <div class="w-180 mRight-30">{{ $t('queryJob.MergeProductNamesWhenFiles') }}</div>
        <div class="w-180 mRight-30">{{ $t('queryJob.ShowTax') }}</div>
        <div class="w-180 mRight-30">{{ $t('queryJob.ShowChinaSurtax') }}</div>
        <div class="w-180 mRight-30">{{ $t('queryJob.ShowMargin') }}</div>
        <div v-show="form.showBond" class="w-180">{{ $t('queryJob.MarginAmount') }}</div>
      </div>
      <div class="flex-row-content" style="line-height: 31px;">
        <div class="w-180 mRight-30">{{ form.dataType | filterDataType }}</div>
        <div class="w-180 mRight-30">
          <el-switch v-model="form.generatingFileMergeSameProduct" no="generatingFileMergeSameProduct" @change="toStatistics" />
        </div>
        <div class="w-180 mRight-30">
          <el-switch v-model="form.showTax" no="showTax" />
        </div>
        <div class="w-180 mRight-30">
          <el-switch v-model="form.showChinaSurtax" no="showChinaSurtax" />
        </div>
        <div class="w-180 mRight-30">
          <el-switch v-model="form.showBond" no="showBond" @change="form.bondAmount=form.showBond?form.bondAmount:0" />
        </div>
        <div v-show="form.showBond" class="w-180">
          <el-input-number v-model="form.bondAmount" no="bondAmount" :precision="2" :controls="false" />
        </div>
      </div>
    </el-form>
    <div v-show="isEdit && cooperateEdit">
      <el-button no="delete" :disabled="!selectedNode" type="danger" @click="toDelete">{{ $t('common.btn.delete') }}</el-button>
    </div>
    <cargo-ag-grid
      config-module="130129"
      :grid-options="gridOptions"
      :column-defs="columnDefs"
      :row-data="rowData"
      style="height: 300px;min-height: 300px;margin-top: 5px"
      @gridReady="params=>{gridApi=params.api}"
    />
    <div class="flex-row-label" style="margin-top: 20px">
      <div class="w-180 mRight-30">{{ $t('SeaExport.TotalPacking') }}</div>
      <div class="w-180 mRight-30">{{ $t('queryJob.TotalNetWeight') }}</div>
      <div class="w-180 mRight-30">{{ $t('SeaExport.TotalWeight') }}</div>
      <div class="w-180 mRight-30">{{ $t('SeaExport.TotalCubage') }}</div>
      <div class="w-180 mRight-30">{{ $t('SeaExport.TotalNumberOfPackages') }}</div>
      <div class="w-180">{{ $t('queryJob.TotalValue') }}</div>
    </div>
    <div class="flex-row-content" style="line-height: 28px;">
      <div class="w-180 mRight-30">{{ form.totalPack }}</div>
      <div class="w-180 mRight-30">{{ form.totalNetWeight }}</div>
      <div class="w-180 mRight-30">{{ form.totalGrossWeight }}</div>
      <div class="w-180 mRight-30">{{ form.totalVolume }}</div>
      <div class="w-180 mRight-30">{{ form.totalNumber }}</div>
      <div class="w-180">{{ form.totalCargoValue.toFixed(4) }}</div>
    </div>
    <div class="flex-row-label">
      <div class="w-180 mRight-30">{{ $t('queryJob.TotalTariff') }}</div>
      <div class="w-180 mRight-30">{{ $t('queryJob.TotalOtherExpenses') }}</div>
      <div class="w-180">{{ $t('WriteOff.total') }}</div>
    </div>
    <div class="flex-row-content" style="line-height: 28px;">
      <div class="w-180 mRight-30">${{ form.totalTariff.toFixed(2) }}</div>
      <div class="w-180 mRight-30">${{ form.otherTotalCharge.toFixed(2) }}</div>
      <div class="w-180">${{ form.total.toFixed(2) }}</div>
    </div>
  </div>
</template>

<script>
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor'
import CargoAgGridSelectEditor from '@/components/Cargo/Common/CargoAgGridSelectEditor'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor'
import moment from 'moment'
import lang from '@/lang'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import { getObjectByCache, getCacheListByKey } from '@/utils/basicDataCache'
import * as NumberUtils from '@/utils/NumberUtils'
import { multiply, getAllSortedRows } from '@/utils/commonUtil'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { toStatistics } from './tabUsCustomsClearanceUtil'
import { Charge } from '@/class/model/act/Charge'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { ChargeUtils } from '@/class/cargo/model/utils/ChargeUtils'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import URL from '@/api/urlTranslator'
import { queryAllUSCommodityCode } from '@/api/usCommodityCode'
import { getSettlementAgentsByCmpIdx } from '@/api/company'
import { batchInsertCharge } from '@/api/clearing/charge'
import { usCustomsClearanceExportSyncImport } from '@/api/booking/usCustomsClearance'
import { queryJobNoLinkFunc } from '@/api/booking/job'

export default {
  name: 'TabUsCustomsClearanceMasterItem',
  filters: {
    filterDataType(val) {
      switch (val) {
        case 1: return lang.t('queryJob.CustomerInformation')
        case 2: return lang.t('queryJob.DeclarationMaterials')
        case 3: return lang.t('queryJob.TopSecretInformation')
        default: return ''
      }
    }
  },
  props: {
    action: { type: String, required: true },
    job: { type: Object, required: true },
    form: { type: Object, required: true },
    showSync: { type: Boolean, default: false },
    cooperateEdit: { type: Boolean, default: true } // 能否修改
  },
  data() {
    /* 包装类型数据 */
    let ctnPacking = getObjectByCache(TYPE_NAMES.basic_data_Packing, 'code', 'CTN')
    if (!ctnPacking) {
      ctnPacking = { code: 'CTN', chineseName: 'CTN', name: 'CTN' }
    }
    let pkgPacking = getObjectByCache(TYPE_NAMES.basic_data_Packing, 'code', 'PKG')
    if (!pkgPacking) {
      pkgPacking = { code: 'PKG', chineseName: 'PKG', name: 'PKG' }
    }
    const packingList = [ctnPacking, pkgPacking]
    return {
      TYPE_NAMES,
      chargeItem499: getObjectByCache(TYPE_NAMES.basic_data_ChargeItem, 'scaleCode', '499'),
      chargeItem501: getObjectByCache(TYPE_NAMES.basic_data_ChargeItem, 'scaleCode', '501'),
      usCommodityCodeList: [],
      chinaAdditionalRateList: [],
      packingList,
      gridOptions: {
        frameworkComponents: {
          CargoAgGridAdvanceSelectEditor,
          CargoAgGridCommonInputEditor,
          CargoAgGridSelectEditor
        },
        singleClickEdit: true,
        rowSelection: 'multiple',
        suppressCellSelection: true,
        suppressRowClickSelection: true,
        onRowDataChanged: event => {
          event.api.clearFocusedCell()
        },
        onCellFocused: event => {
          const nodes = event.api.rowModel.rowsToDisplay
          this.selectedNode = nodes[event.rowIndex] || null
        },
        onSortChanged: event => {
          if (this.selectedNode) {
            event.api.setFocusedCell(this.selectedNode.rowIndex, event.columnApi.getAllDisplayedColumns()[0])
          }
        },
        context: {
          componentParent: this
        }
      },
      selectedNode: null,
      gridApi: null,
      ignoreCellChange: false // 忽略cellChange事件标识，用于避免循环执行
    }
  },
  computed: {
    readonly() {
      if (!this.cooperateEdit) return true
      return this.action === 'look'
    },
    isEdit() {
      if (!this.cooperateEdit) return false
      const val = this.form.dataType ? Number(this.form.dataType) : 0
      switch (val) {
        case 1: return (this.$checkPermission(['tab_UsCustomsClearance_customerEdit']) && !this.readonly)
        case 2: return (this.$checkPermission(['tab_UsCustomsClearance_reportEdit']) && !this.readonly)
        case 3: return (this.$checkPermission(['tab_UsCustomsClearance_secretEdit']) && !this.readonly)
        default: return !this.readonly
      }
    },
    lob() {
      return this.job.lob
    },
    columnDefs() {
      return [
        {
          headerName: '',
          headerCheckboxSelection: true,
          checkboxSelection: true,
          width: 55,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        }, {
          headerName: this.$t(this.$t('CargoMsg.Cargo_SequenceNumber')),
          field: 'serialNumber',
          width: 80,
          editable: params => this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 0
            }
          }
        }, {
          headerName: this.$t(this.$t('queryJob.businessNumber')),
          field: 'jobNo',
          width: 150
        }, {
          headerName: this.$t(this.$t('queryJob.CustomerName')),
          field: 'customerProductName',
          width: 190,
          valueFormatter: params => {
            const item = this.usCommodityCodeList.find(p => p.code === params.value)
            return item ? item._label : params.value
          },
          editable: params => this.isEdit,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              selectType: TYPE_NAMES.static_data_UsCommodityCode,
              callbackParams: { key: 'code' },
              callbackMethodType: 'value',
              filterable: true,
              tagName: '_label',
              staticOptions: this.enabledUsCommodityCodeList
            }
          },
          onCellValueChanged: params => this.onCellChange(params)
        }, {
          headerName: this.$t(this.$t('queryJob.CustomsClearanceProductName')),
          field: 'customsClearanceProductName',
          width: 190,
          valueFormatter: params => {
            const item = this.usCommodityCodeList.find(p => p.code === params.value)
            return item ? item._label : params.value
          },
          editable: params => this.isEdit,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              selectType: TYPE_NAMES.static_data_UsCommodityCode,
              callbackParams: { key: 'code' },
              callbackMethodType: 'value',
              filterable: true,
              tagName: '_label',
              staticOptions: this.enabledUsCommodityCodeList
            }
          },
          onCellValueChanged: params => this.onCellChange(params)
        }, {
          headerName: this.$t(this.$t('queryJob.NumberOfPackages')),
          field: 'packageNumber',
          width: 80,
          editable: params => this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 0
            }
          },
          onCellValueChanged: params => this.onCellChange(params)
        }, {
          headerName: this.$t(this.$t('SeaExport.PackageType')),
          field: 'packageType',
          width: 90,
          valueFormatter: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Packing, 'code', params.value, 'name') || params.value
          },
          editable: params => this.isEdit,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              selectType: TYPE_NAMES.static_data_Packing,
              callbackParams: { key: 'code' },
              callbackMethodType: 'value',
              filterable: true,
              staticOptions: this.packingList
            }
          }
        }, {
          headerName: this.$t(this.$t('SeaExport.NetWeight')),
          field: 'netWeight',
          width: 70,
          valueFormatter: params => {
            return Number(params.value) || 0
          },
          editable: params => this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 4
            }
          },
          onCellValueChanged: params => this.onCellChange(params)
        }, {
          headerName: this.$t(this.$t('SeaExport.Weight')),
          field: 'grossWeight',
          width: 70,
          valueFormatter: params => {
            return Number(params.value) || 0
          },
          editable: params => this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 4
            }
          },
          onCellValueChanged: params => this.onCellChange(params)
        }, {
          headerName: this.$t(this.$t('SeaExport.Cubage')),
          field: 'volume',
          width: 70,
          valueFormatter: params => {
            return Number(params.value) || 0
          },
          editable: params => this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 3
            }
          },
          onCellValueChanged: params => this.onCellChange(params)
        }, {
          headerName: this.$t(this.$t('queryJob.NumberOfGoods')),
          field: 'goodsNumber',
          width: 90,
          editable: params => this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 0
            }
          },
          onCellValueChanged: params => this.onCellChange(params)
        }, {
          headerName: this.$t(this.$t('queryJob.CustomsClearanceUnit')),
          field: 'customsClearanceUnit',
          width: 90,
          editable: params => this.isEdit,
          cellEditor: 'CargoAgGridSelectEditor',
          cellEditorParams: {
            selectProps: {
              style: 'width: 100%'
            },
            options: [{ value: 'DOZ' }, { value: 'KG' }, { value: 'NO' }, { value: 'M2' }, { value: 'DPR' }],
            tagName: 'value',
            tagValue: 'value'
          }
        }, {
          headerName: this.$t(this.$t('queryJob.UnitWeight')),
          field: 'unitWeight',
          width: 90
        }, {
          headerName: this.$t(this.$t('queryJob.ItemPricing')),
          field: 'productPrice',
          width: 90,
          valueFormatter: params => {
            return Number(params.value) || 0
          },
          editable: params => this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 4
            }
          },
          onCellValueChanged: params => this.onCellChange(params)
        }, {
          headerName: this.$t(this.$t('queryJob.TotalPriceOfGoods')),
          field: 'totalProductPrice',
          width: 90,
          valueFormatter: params => {
            return typeof params.value === 'number' ? params.value.toFixed(4) : params.value
          },
          editable: params => this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 4
            }
          },
          onCellValueChanged: params => this.onCellChange(params)
        }, {
          headerName: this.$t(this.$t('queryJob.ChinaAdditionalTaxRate')),
          field: 'chinaAdditionalRate',
          width: 115,
          valueFormatter: params => {
            if (Number(params.value)) {
              return params.value + '%'
            }
            return ''
          },
          editable: params => this.isEdit,
          cellEditor: 'CargoAgGridSelectEditor',
          cellEditorParams: params => {
            return {
              selectProps: {
                filterable: true,
                allowCreate: true,
                style: 'width: 100%'
              },
              options: this.chinaAdditionalRateList,
              tagName: 'value',
              tagValue: 'value'
            }
          },
          onCellValueChanged: params => this.onCellChange(params)
        }, {
          headerName: this.$t(this.$t('queryJob.ChinasSurtaxTariff')),
          field: 'chinaAdditionalTaxRule',
          width: 130
        }, {
          headerName: this.$t(this.$t('queryJob.ChinaSurtaxClause')),
          field: 'chinaAdditionalTaxClause',
          width: 190
        }, {
          headerName: this.$t(this.$t('common.createBy')),
          field: 'createdBy',
          width: 130,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t(this.$t('common.dateCreated')),
          field: 'dateCreated',
          width: 130,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        }, {
          headerName: this.$t(this.$t('common.modifiedBy')),
          field: 'modifiedBy',
          width: 130,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t(this.$t('common.dateModified')),
          field: 'dateModified',
          width: 130,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        }
      ]
    },
    rowData() {
      return this.form.usCustomsClearanceCargoList
    },
    deletedUsCustomsClearanceCargoKeys() {
      return this.form.deletedUsCustomsClearanceCargoKeys
    },
    enabledUsCommodityCodeList() {
      return this.usCommodityCodeList.filter(p => p.status === 1)
    }
  },
  created() {
    queryAllUSCommodityCode().then(res => {
      const taxRule01 = this.toTaxRule('9903.88.01')
      const taxRule02 = this.toTaxRule('9903.88.02')
      const taxRule03 = this.toTaxRule('9903.88.03')
      const taxRule15 = this.toTaxRule('9903.88.15')
      const taxRule42 = this.toTaxRule('9903.88.42')
      for (const item of res.data) {
        item._label = `${item.commodityName}-${item.hsCode}-${item.descriptionCode}`
        this.attachTaxRuleInfo(item, taxRule01, taxRule02, taxRule03, taxRule15, taxRule42)
      }
      this.usCommodityCodeList = res.data
      if (this.gridApi) {
        this.gridApi.setRowData(this.rowData)
      }
    })
  },
  methods: {
    toTaxRule(code) {
      const chargeItem = getObjectByCache(TYPE_NAMES.basic_data_ChargeItem, 'scaleCode', code)
      if (chargeItem) {
        const rate = []
        if (chargeItem.suitApRate) {
          rate.push(Number((chargeItem.defaultApRate * 100).toFixed(6)))
        }
        if (chargeItem.suitSecondApRate) {
          rate.push(Number((chargeItem.secondApRate * 100).toFixed(6)))
        }
        return { code, rate, clause: chargeItem.chargecode }
      }
      return { code, rate: [], clause: '' }
    },
    attachTaxRuleInfo(data, taxRule01, taxRule02, taxRule03, taxRule15, taxRule42) {
      let taxRule = null
      switch (data.chinaAdditionalTaxRule) {
        case '9903.88.01':
          taxRule = taxRule01
          break
        case '9903.88.02':
          taxRule = taxRule02
          break
        case '9903.88.03':
          taxRule = taxRule03
          break
        case '9903.88.15':
          taxRule = taxRule15
          break
        case '9903.88.42':
          taxRule = taxRule42
          break
      }
      if (taxRule) {
        data.chinaAdditionalRate = taxRule.rate
        data.chinaAdditionalTaxClause = taxRule.clause
      } else {
        data.chinaAdditionalRate = []
        data.chinaAdditionalTaxClause = ''
      }
    },
    export7501(useCustomerProductName = false) {
      const rows = this.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectData'))
        return null
      }
      let minJobNoRow = rows[0]
      for (let i = 1; i < rows.length; ++i) {
        if (rows[i].jobNo < minJobNoRow.jobNo) {
          minJobNoRow = rows[i]
        }
      }
      const sessionId = this.$store.getters.userInfo.sessionId
      const jobKey = this.job.uuid
      const usCustomsClearanceKey = minJobNoRow.usCustomsClearanceUuid
      const generatingFileMergeSameProduct = this.form.generatingFileMergeSameProduct
      const showTax = this.form.showTax
      const showChinaSurtax = this.form.showChinaSurtax
      const showBond = this.form.showBond
      const bondAmount = this.form.bondAmount
      const usCustomsClearanceCargoKeys = Array.from(rows, p => p.uuid).join(',')
      window.open(`${URL.booking.export7501}?sessionId=${sessionId}&jobKey=${jobKey}&usCustomsClearanceKey=${usCustomsClearanceKey}` +
        `&generatingFileMergeSameProduct=${generatingFileMergeSameProduct}&showTax=${showTax}&showChinaSurtax=${showChinaSurtax}` +
        `&showBond=${showBond}&bondAmount=${bondAmount}&usCustomsClearanceCargoKeys=${usCustomsClearanceCargoKeys}` +
        `&useCustomerProductName=${useCustomerProductName}`)
    },
    getSelectedRows() {
      const result = []
      const nodes = this.gridApi.rowModel.rowsToDisplay
      for (const node of nodes) {
        if (node.selected) {
          result.push(node.data)
        }
      }
      return result
    },
    async generateCostCharge() {
      const loading = getLoading4Cxt(this)
      try {
        /* 初始化应收费用 */
        const obj = new Charge().fillDefaultValue().getData()
        const ajaxResults = []
        obj.jobUuid = this.job.uuid
        obj.billingUuid = null
        obj.invoiceUuid = null
        obj.billingPaymentUuid = null
        obj.confirmBillUuid = null
        obj.diffChargeUuid = null
        obj.agentSharedBillingUuid = null
        obj.accountId = this.job.customerId || this.job.bookingAgent
        if (obj.accountId > 0) {
          // 设置开票抬头
          ajaxResults.push(ChargeUtils.updateDefaultInvoiceTitle([obj]))
          // 默认的结算代理
          ajaxResults.push(this.getSettlementByCompanyId(obj))
        }
        obj.oversea = true
        obj.inputBy = this.$store.getters.userId
        obj.inputDate = moment().format('YYYY-MM-DD')
        obj.currency = 'USD'
        const localCurrency = RateUtil.localCurrencyByOffice()
        obj.localCurrency = localCurrency
        ajaxResults.push(
          RateUtil.getForeignExchangeRateByJob(localCurrency, obj.currency, this.job, 0).then(value => {
            obj.exchangeRate = value
          })
        )
        const office = this.$store.getters.currentOffice
        if (office && String(office.taxRate) !== 'NaN') {
          obj.taxRate = office.taxRate
        }
        obj.measure = this.getMeasureData()
        obj.branchId = office.officeId
        obj.receivable = true
        obj.unitPriceIncludeTax = false
        obj.serialNumber = this.job.charges.filter(p => p.receivable).length + 1
        await ajaxResults

        /* 设置费用名称为关税 */
        obj.changer = this.$store.getters.userId
        const chargeItem = getObjectByCache(TYPE_NAMES.basic_data_ChargeItem, 'zhName', this.$t('queryJob.CustomsDuty'))
        if (chargeItem) {
          obj.chargeItemId = chargeItem.itemId
          obj.quantity = 1
          obj.serviceType = chargeItem.serviceType
        }

        /* 同步费用总额 */
        obj.unitRate = NumberUtils.roundHalfUp(this.getArTotal(), 3)
        ChargeUtils.calculateTax(obj, multiply(obj.unitRate, obj.quantity), obj.taxRate) // 不含税价

        obj.businessDate = this.lob === 'SE' || this.lob === 'AE' || this.lob === 'RE' ? this.job.etd : this.job.eta
        await batchInsertCharge([obj])
        this.$message.success(this.$t('queryJob.AccountsReceivableGeneratedSuccessfully'))
        this.$emit('chargeChange')
      } finally {
        loading.close()
      }
    },
    // 根据结算对象，获取结算代理
    async getSettlementByCompanyId(charge) {
      const accountId = charge.accountId
      if (!accountId || accountId <= 0) return
      const chargeAccount = getObjectByCache(TYPE_NAMES.basic_data_Company, 'cmpIdx', charge.accountId)
      const res = await getSettlementAgentsByCmpIdx(charge.accountId)
      let dbSettlementAgents = res.data
      if (!dbSettlementAgents) dbSettlementAgents = []
      if (chargeAccount) {
        const index = dbSettlementAgents.findIndex(p => p.uuid === chargeAccount.uuid)
        if (index < 0) {
          dbSettlementAgents.push(chargeAccount)
        }
      }
      charge.settlementAgentId = dbSettlementAgents[0].cmpIdx
    },
    getMeasureData() {
      const l = getCacheListByKey(TYPE_NAMES.basic_data_ChargeUnit)
      let measure = ''
      for (const item of l) {
        if (item && item.ifDefault && item.unit) {
          measure = item.code
        }
      }
      return measure
    },
    // 获取应收总计
    getArTotal() {
      let totalFee499 = 0
      let totalFee501 = 0
      let totalChinaAdditionalRate = 0
      for (const row of this.rowData) {
        const usCommodityCode = this.usCommodityCodeList.find(p => p.code === row.customsClearanceProductName)
        if (usCommodityCode) {
          if (usCommodityCode.containAdditionalTax499 && this.chargeItem499) {
            let fee499 = (Number(row.totalProductPrice) || 0) * (this.chargeItem499.defaultArRate || 0)
            if (this.chargeItem499.arIntervalType === 0) {
              if (this.chargeItem499.arAmountIntervalMin && fee499 < this.chargeItem499.arAmountIntervalMin) {
                fee499 = this.chargeItem499.arAmountIntervalMin
              } else if (this.chargeItem499.arAmountIntervalMax && fee499 > this.chargeItem499.arAmountIntervalMax) {
                fee499 = this.chargeItem499.arAmountIntervalMax
              }
            }
            totalFee499 += fee499
          }
          if (usCommodityCode.containAdditionalTax501 && this.chargeItem501) {
            let fee501 = (Number(row.totalProductPrice) || 0) * (this.chargeItem501.defaultArRate || 0)
            if (this.chargeItem501.arIntervalType === 0) {
              if (this.chargeItem501.arAmountIntervalMin && fee501 < this.chargeItem501.arAmountIntervalMin) {
                fee501 = this.chargeItem501.arAmountIntervalMin
              } else if (this.chargeItem501.arAmountIntervalMax && fee501 > this.chargeItem501.arAmountIntervalMax) {
                fee501 = this.chargeItem501.arAmountIntervalMax
              }
            }
            totalFee501 += fee501
          }
          const chargeItem = getObjectByCache(TYPE_NAMES.basic_data_ChargeItem, 'scaleCode', row.chinaAdditionalTaxRule)
          if (chargeItem) {
            totalChinaAdditionalRate += (Number(row.totalProductPrice) || 0) * (chargeItem.defaultArRate || 0)
          }
        }
      }
      return Number((this.form.totalTariff + this.form.totalFee056 + totalFee499 + totalFee501 + totalChinaAdditionalRate).toFixed(2))
    },
    async generateSellingCharge() {
      const loading = getLoading4Cxt(this)
      try {
        /* 初始化应付费用 */
        const obj = new Charge().fillDefaultValue().getData()
        const ajaxResults = []
        obj.jobUuid = this.job.uuid
        obj.billingUuid = null
        obj.invoiceUuid = null
        obj.billingPaymentUuid = null
        obj.confirmBillUuid = null
        obj.diffChargeUuid = null
        obj.agentSharedBillingUuid = null
        obj.accountId = this.job.bookingAgent || this.job.customerId
        if (obj.accountId > 0) {
          // 设置开票抬头
          ajaxResults.push(ChargeUtils.updateDefaultInvoiceTitle([obj]))
          // 默认的结算代理
          ajaxResults.push(this.getSettlementByCompanyId(obj))
        }
        obj.oversea = true
        obj.inputBy = this.$store.getters.userId
        obj.inputDate = moment().format('YYYY-MM-DD')
        obj.currency = 'USD'
        const localCurrency = RateUtil.localCurrencyByOffice()
        obj.localCurrency = localCurrency
        ajaxResults.push(
          RateUtil.getForeignExchangeRateByJob(localCurrency, obj.currency, this.job, 0).then(value => {
            obj.exchangeRate = value
          })
        )
        const office = this.$store.getters.currentOffice
        obj.measure = this.getMeasureData()
        obj.branchId = office.officeId
        obj.receivable = false
        obj.unitPriceIncludeTax = false
        obj.serialNumber = this.job.charges.filter(p => !p.receivable).length + 1
        await ajaxResults

        /* 设置费用名称为关税 */
        obj.changer = this.$store.getters.userId
        const chargeItem = getObjectByCache(TYPE_NAMES.basic_data_ChargeItem, 'zhName', this.$t('queryJob.CustomsDuty'))
        if (chargeItem) {
          obj.chargeItemId = chargeItem.itemId
          obj.quantity = 1
          obj.serviceType = chargeItem.serviceType
        }

        /* 同步费用总额 */
        obj.unitRate = NumberUtils.roundHalfUp(this.form.total, 3)
        ChargeUtils.calculateTax(obj, multiply(obj.unitRate, obj.quantity), obj.taxRate) // 不含税价

        obj.businessDate = this.lob === 'SE' || this.lob === 'AE' || this.lob === 'RE' ? this.job.etd : this.job.eta
        await batchInsertCharge([obj])
        this.$message.success(this.$t('queryJob.PayableExpensesGeneratedSuccessfully'))
        this.$emit('chargeChange')
      } finally {
        loading.close()
      }
    },
    async exportSyncImport() {
      const loading = getLoading4Cxt(this)
      try {
        let isOperating = this.job.jobState === SystemConstants.STATE_OPERATING.code
        if (isOperating) {
          await queryJobNoLinkFunc({ jobNo: this.job.relatedJob }).then(res => {
            const data = res.data
            if (data.jobState !== SystemConstants.STATE_OPERATING.code) {
              isOperating = false
              return
            }
            if (data.lclList && data.lclList.length > 0) {
              for (const item of data.lclList) {
                if (item.jobState !== SystemConstants.STATE_OPERATING.code) {
                  isOperating = false
                  return
                }
              }
            }
          })
        }
        if (!isOperating) {
          this.$message.warning(this.$t('queryJob.NotOperatingCannotSynchronized'))
          return
        }
        await usCustomsClearanceExportSyncImport({ jobKey: this.job.uuid }).then(() => {
          this.$message.success(this.$t('Message.SynchronizationSucceeded'))
        })
      } finally {
        loading.close()
      }
    },
    toDelete() {
      this.$confirm(this.$t('queryJob.TheSureYouWantData'), this.$t('Message.Prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        const index = this.rowData.findIndex(p => p === this.selectedNode.data)
        this.deletedUsCustomsClearanceCargoKeys.push(this.rowData[index].uuid)
        this.rowData.splice(index, 1)
        this.toStatistics()
      }).catch(() => { })
    },
    onCellChange(params) {
      if (this.ignoreCellChange) {
        this.ignoreCellChange = false
        return
      }
      const { node, data } = params
      const filed = params.colDef.field
      switch (filed) {
        case 'customerProductName':
          if (!data.customsClearanceProductName) {
            data.customsClearanceProductName = data.customerProductName
            node.setDataValue('customsClearanceProductName', data.customerProductName)
          }
          break
        case 'customsClearanceProductName':
          {
            const usCommodityCode = this.usCommodityCodeList.find(p => p.code === data.customsClearanceProductName)
            this.chinaAdditionalRateList = []
            data.chinaAdditionalRate = ''
            if (usCommodityCode) {
              if (usCommodityCode.chinaAdditionalRate) {
                this.chinaAdditionalRateList = Array.from(usCommodityCode.chinaAdditionalRate, value => { return { value } })
                if (this.chinaAdditionalRateList.length > 0) {
                  data.chinaAdditionalRate = this.chinaAdditionalRateList[0].value
                }
              }
              data.chinaAdditionalTaxRule = usCommodityCode.chinaAdditionalTaxRule
              data.chinaAdditionalTaxClause = usCommodityCode.chinaAdditionalTaxClause
            } else {
              data.chinaAdditionalTaxRule = ''
              data.chinaAdditionalTaxClause = ''
            }
            node.setDataValue('chinaAdditionalRate', data.chinaAdditionalRate)
            node.setDataValue('chinaAdditionalTaxRule', data.chinaAdditionalTaxRule)
            node.setDataValue('chinaAdditionalTaxClause', data.chinaAdditionalTaxClause)
            this.toStatistics()
          }
          break
        case 'packageNumber':
          this.form.totalPack = 0
          for (const row of this.rowData) {
            this.form.totalPack += Number(row.packageNumber) || 0
          }
          break
        case 'netWeight':
          this.resetUnitWeight(node, data)
          this.toStatistics()
          break
        case 'grossWeight':
          this.toStatistics()
          break
        case 'volume':
          this.form.totalVolume = 0
          for (const row of this.rowData) {
            this.form.totalVolume += Number(row.volume) || 0
          }
          break
        case 'goodsNumber':
          this.form.totalNumber = 0
          for (const row of this.rowData) {
            this.form.totalNumber += Number(row.goodsNumber) || 0
          }
          this.resetUnitWeight(node, data)
          break
        case 'productPrice':
          data.totalProductPrice = (Number(data.productPrice) || 0) * (Number(data.goodsNumber) || 0)
          this.ignoreCellChange = true
          node.setDataValue('totalProductPrice', data.totalProductPrice)
          this.toStatistics()
          break
        case 'totalProductPrice':
          {
            const goodsNumber = (Number(data.goodsNumber) || 0)
            if (goodsNumber) {
              data.productPrice = (Number(data.totalProductPrice) || 0) / goodsNumber
              data.productPrice = Number(data.productPrice.toFixed(4))
            } else {
              data.productPrice = 0
            }
            this.ignoreCellChange = true
            node.setDataValue('productPrice', data.productPrice)
            this.toStatistics()
          }
          break
        case 'chinaAdditionalRate':
          {
            const chinaAdditionalRate = Number(data.chinaAdditionalRate)
            if (!chinaAdditionalRate && chinaAdditionalRate !== 0) {
              data.chinaAdditionalRate = 0
              node.setDataValue('chinaAdditionalRate', data.chinaAdditionalRate)
            } else {
              this.toStatistics()
            }
          }
          break
      }
    },
    resetUnitWeight(node, data) {
      const netWeight = Number(data.netWeight)
      const goodsNumber = Number(data.goodsNumber)
      if (netWeight && goodsNumber) {
        data.unitWeight = netWeight / data.goodsNumber
        data.unitWeight = Number(data.unitWeight.toFixed(4))
      } else {
        data.unitWeight = 0
      }
      node.setDataValue('unitWeight', data.unitWeight)
    },
    toStatistics() {
      const rows = getAllSortedRows(this.gridApi)
      let minJobNoRow = rows[0]
      for (let i = 1; i < rows.length; ++i) {
        if (rows[i].jobNo < minJobNoRow.jobNo) {
          minJobNoRow = rows[i]
        }
      }
      const minUsCustomsClearance = this.form.subUsCustomsClearance.find(p => p.uuid === minJobNoRow.usCustomsClearanceUuid)
      if (minUsCustomsClearance) {
        this.form.countryOfOrigin = minUsCustomsClearance.countryOfOrigin
      }
      toStatistics(rows, this.enabledUsCommodityCodeList, this.form, this.job.lob)
    },
    // 组装打印参数
    getPrintData() {
      const rows = this.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectData'))
        return null
      }
      let minJobNoRow = rows[0]
      for (let i = 1; i < rows.length; ++i) {
        if (rows[i].jobNo < minJobNoRow.jobNo) {
          minJobNoRow = rows[i]
        }
      }
      const form = { generatingFileMergeSameProduct: this.form.generatingFileMergeSameProduct }
      const minUsCustomsClearance = this.form.subUsCustomsClearance.find(p => p.uuid === minJobNoRow.usCustomsClearanceUuid)
      if (minUsCustomsClearance) {
        form.countryOfOrigin = minUsCustomsClearance.countryOfOrigin
      }
      toStatistics(rows, this.enabledUsCommodityCodeList, form, this.job.lob)
      const statisticsInfo = {
        GENERATING_FILE_MERGE_SAME_PRODUCT: this.form.generatingFileMergeSameProduct,
        SHOW_TAX: this.form.showTax,
        SHOW_CHINA_SURTAX: this.form.showChinaSurtax,
        SHOW_BOND: this.form.showBond,
        BOND_AMOUNT: this.form.bondAmount,
        TOTAL_PACK: form.totalPack,
        TOTAL_NET_WEIGHT: form.totalNetWeight,
        TOTAL_GROSS_WEIGHT: form.totalGrossWeight,
        TOTAL_VOLUME: form.totalVolume,
        TOTAL_NUMBER: form.totalNumber,
        TOTAL_CARGO_VALUE: form.totalCargoValue,
        TOTAL_TARIFF: form.totalTariff,
        TOTAL_FEE056: form.totalFee056,
        TOTAL_FEE499: form.totalFee499,
        TOTAL_FEE501: form.totalFee501,
        TOTAL_CHINA_ADDITIONAL_RATE: form.totalChinaAdditionalRate,
        OTHER_TOTAL_CHARGE: form.otherTotalCharge,
        TOTAL: form.total
      }
      const params = {}
      params.US_CUSTOMS_CLEARANCE_UUID = minJobNoRow.usCustomsClearanceUuid
      params.US_CUSTOMS_CLEARANCE_CARGO_UUID = Array.from(rows, p => p.uuid).join(',')
      params.statisticsInfo = JSON.stringify(statisticsInfo)
      params.JOB_UUID = this.job.uuid
      params.jobuuid = this.job.uuid
      params.usDataType = this.form.dataType
      params.category = 'US_CLEAR_CUSTOMS'
      params.jobNo = this.job.jobNo
      // this.$logger.log('params', params)
      return params
    }
  }
}
</script>

<style scoped>
.flex-row-label {
  display: flex;
  padding-top: 5px;
}
.flex-row-content {
  display: flex;
  padding-bottom: 10px;
}
.w-180 {
  width: 180px;
}
.mRight-30 {
  margin-right: 30px;
}
</style>
